import React from "react";

import List from "../List/List";
import {ASSETS_LIABILITIES_TYPES} from "../constants";
import SyncWithRiskProfilePopup from "../List/components/SyncWithRiskProfilePopup";
import {LIABILITY_DATA_UID} from "../../RiskProfiling/constants";
import {buildLiabilities} from "../utils";


const LiabilitiesList = (props) => {
  const {
    allowSync=true,
    customerId,
    onUpdate,
    name,
    helpText,
    data,
    showNewBadge,
  } = props;

  const liabilities = React.useMemo(() => buildLiabilities(data), [data.updatedAt]);
  const handleUpdate = React.useCallback((action, categoryId, item) =>
    onUpdate(ASSETS_LIABILITIES_TYPES.LIABILITIES, action, categoryId, item),
    [onUpdate]);

  return (
    <>
      <List
        customerId={customerId}
        stepName={name}
        helpText={helpText}
        data={liabilities}
        loading={data.loading}
        error={data.error}
        onUpdate={handleUpdate}
        objectType={ASSETS_LIABILITIES_TYPES.LIABILITIES}
        totalColor={'orange'}
        children={props.children}
        showNewBadge={showNewBadge}
      />
      {!!allowSync && (
        <SyncWithRiskProfilePopup
          customerId={customerId}
          flagName={'liabilities_synced'}
          onUpdate={handleUpdate}
          warnPopupTitle={'Verbindlichkeiten aus altem Risikoprofil prüfen'}
          syncPopupTitle={'Vorhandene Verbindlichkeiten geprüft'}
          syncPopupDescription={
            'Es wurden bestehende Verbindlichkeiten aus dem letzten Risikoprofil gefunden. ' +
            'Bitte wählen Sie, welche Sie übernehmen möchten.'
          }
          syncPopupNoItemsDescription={'Es wurden keine Verbindlichkeiten aus dem letzten Risikoprofil gefunden.'}
          itemSingleLabel={'Verbindlichkeit'}
          itemPluralLabel={'Verbindlichkeiten'}
          questionUID={LIABILITY_DATA_UID}
          syncIncompleteTitle={'Verbindlichkeiten konnten nicht eindeutig zugeordnet werden'}
          syncIncompleteDescription={<>
            Verbindlichkeiten aus dem letzten Risikoprofil konnten keinem passenden Kategorie zugeordnet werden.
            Diese Positionen wurden vorläufig der Option „Sonstige“ oder “Weitere” zugewiesen.<br/><br/>
            Bitte prüfen Sie diese. Auf der folgenden Seite können Sie die Zuordnung bei Bedarf manuell anpassen.
          </>}
        >
          Möchten Sie nach vorhandenen Verbindlichkeiten prüfen und gegebenenfalls in das neue Profil übernehmen?
        </SyncWithRiskProfilePopup>
      )}
    </>
  )
};

export default LiabilitiesList;